import React from 'react'

import * as Popover from '@radix-ui/react-popover'
import { TbLink } from 'react-icons/tb'

import { LinkEditorPanel } from '@/components/common/TextArea/RichTextArea/menus/components/LinkEditorPanel'
import { Surface } from '@/components/common/TextArea/RichTextArea/menus/components/Surface'
import { Toolbar } from '@/components/common/TextArea/RichTextArea/menus/components/Toolbar'

export type EditLinkPopoverProps = {
  modal?: boolean
  contentProps?: Popover.PopoverContentProps
  triggerProps?: Popover.PopoverTriggerProps
  onSetLink: (link: string, openInNewTab?: boolean) => void
}

export const EditLinkPopover: React.FC<EditLinkPopoverProps> = ({
  modal = true,
  contentProps,
  triggerProps,
  onSetLink,
}) => {
  const { disabled, ...restTriggerProps } = triggerProps ?? {}

  return (
    <Popover.Root modal={modal}>
      <Popover.Trigger asChild {...restTriggerProps}>
        <Toolbar.Button aria-label="Add link" disabled={disabled}>
          <TbLink className="w-4 h-4" />
        </Toolbar.Button>
      </Popover.Trigger>
      <Popover.Content sideOffset={2} {...contentProps}>
        <Surface className="p-2 w-fit shadow-md">
          <LinkEditorPanel onSetLink={onSetLink} />
        </Surface>
      </Popover.Content>
    </Popover.Root>
  )
}
